import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    fields: {
      '& .MuiFormControl-fullWidth': { margin: '6px 0px' },
      '& .MuiOutlinedInput-multiline': { display: 'inline-table', padding: 14 },
      '& .MuiGrid-item': { padding: '8px 0px' },
    },
    buttons: { marginTop: 15 },
    tableRow: {
      width: 100,
      paddingRight: 0,
      paddingLeft: 16,
      fontSize: 12,
      height: 20,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    bold: { fontWeight: 'bold', fontSize: 12 },
    titleGrid: {
      padding: '8px',
      border: `1px solid ${palette.lightGray}`,
      borderRadius: '8px',
      margin: '4px 0px',
    },
    autocompleteCompany: {
      cursor: 'pointer',
      width: '100%',
      display: 'flex',
      borderColor: palette.borderGray,
      padding: '0px 0px 0px 4px !important',

      '& .MuiButton-label': { justifyContent: 'flex-start' },
    },
    errorSamePartnerButton: { borderColor: palette.red },
    itemSelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        lineHeight: 0,
      },
    },
    companyCell: {
      width: 150,
      minWidth: 150,
      maxWidth: 150,
      cursor: 'pointer',
      padding: '0px 0px 0px 16px',
      '& .MuiTableCell-root': {
        paddingLeft: 0,
      },
    },
    name: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 200,
      minWidth: 200,
      maxWidth: 200,
    },
    title: {
      fontSize: 12,
    },
    titleBold: {
      fontSize: 12,
      fontWeight: 500,
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      padding: 15,

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    checkboxCell: {
      width: '10%',
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    checkboxActivateAll: {
      '& .MuiCheckbox-colorSecondary.Mui-checked': {},
    },
    selectClientButton: { padding: 0 },
    expandIcon: { fontSize: '25px !important' },
    stepIconComplete: {
      color: palette.green,
      backgroundColor: 'white',
      borderRadius: '50%',
      position: 'relative',
      transition: 'all 0.7s ease-in-out',
    },
    stepIcon: {
      color: palette.sideGray,
      backgroundColor: 'white',
      borderRadius: '50%',
    },
    progressLine: {
      color: palette.sideGray,
      opacity: 0.6,
      alignItems: 'flex-start',
      display: 'flex',
      marginBottom: '20px',
    },
    progressLineComplete: {
      color: palette.green,
      alignItems: 'flex-start',
      display: 'flex',
      marginBottom: '20px',
      transition: 'all 0.5s ease-in-out',
    },
    stepLabel: { fontSize: 11 },
    stepLabelConfirm: { marginLeft: '-20px', fontSize: 11 },
    stepsGrid: {
      textAlign: 'center',
      display: 'block',
      margin: '-35px !important',
    },
    optionsCard: { display: 'flex', alignItems: 'center' },
    successIcon: { color: palette.green },
  });
export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: '100%',
    overflowX: 'auto',
  },
};
